import { render, staticRenderFns } from "./provider-description.vue?vue&type=template&id=015a17e8&scoped=true&"
import script from "./provider-description.vue?vue&type=script&lang=js&"
export * from "./provider-description.vue?vue&type=script&lang=js&"
import style0 from "./provider-description.vue?vue&type=style&index=0&id=015a17e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a17e8",
  null
  
)

export default component.exports